export default __webpack_public_path__ + "static/banner-finance-how-technology-can-help-hack-your-finances-cac088b9c039dfd31c94373b31302487.jpg";